<template>
    <FormModel
        :action="submit" :labelCol="{span:4}" :model="config.secret"
        :rules="rules" :wrapperCol="{span: 20}" style="width: 560px;">
        <a-form-model-item label="平台展示" required>
            <a-radio-group v-model="config.secret.platform">
                <a-radio :value="true">允许EFOTO推荐展示</a-radio>
                <a-radio :value="false">禁止EFOTO推荐展示</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="安全等级" prop="type">
            <a-radio-group v-model="config.secret.type">
                <a-radio :value="1">公开访问</a-radio>
                <a-radio :value="2">密码解锁</a-radio>
                <a-radio :value="3">人脸解锁</a-radio>
                <a-radio :value="4">号码解锁</a-radio>
            </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="设置密码" required v-if="config.secret.type===2">
            <a-input-password placeholder="请设置访问密码" v-model="config.secret.password"/>
        </a-form-model-item>
    </FormModel>
</template>

<script>
    import func from "../../../../utils/func";
    import cache from "../../../../utils/cache";
    import FormModel from "../../../../comps/FormModel";

    export default {
        name: "Secret",
        props: {album: Object},
        components: {FormModel},
        data() {
            return {
                config: {
                    secret: {
                        type: 1,
                        password: "",
                        platform: true,
                    }
                },
                rules: {
                    type: {required: true}
                }
            }
        },
        mounted() {
            this.config = func.copyObject(this.album.config);
        },
        methods: {
            submit() {
                return cache.v1.album.setConfig(this.album.id, this.config)
                    .then(() => this.album.config = this.config);
            }
        }
    }
</script>

<style scoped>

</style>
